module.exports = __webpack_public_path__ + "group_buy/groupbuy_banner_mobile-a8d528a78ecd008ec8440aa2f7545acd.png";